module.exports = __webpack_public_path__ + "img/banner0108.cf4f2c7b.png";